import { CurrentUserInfo } from '@deltek/specification-client/core/Models/currentUserInfo'
import { User } from '@deltek/specification-client/core/Models/user'
import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { ViewFirmContacts } from '@deltek/specification-client/core/Widgets/ProductListing/Details/GeneralInfo/ViewFirmContacts'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    itemContainer: {
        paddingTop: theme.spacing(1),
        width: 'calc(100% - 85px)',
    },
    linksHeadingContainer: {
        width: 85,
    },
    linksHeading: {
        marginRight: theme.spacing(3),
        textTransform: 'uppercase',
        fontSize: pxToRem(13),
        fontWeight: 500,
        marginTop: theme.spacing(1.25),
    },
    noContacts: {
        lineHeight: pxToRem(theme.spacing(2.25)),
        color: '#242424',
    },
}))

interface FirmContactsProps {
    assignedContactUsers?: Partial<User>[]
    productName: string
    currentUserInfo?: CurrentUserInfo
    activeFirmName?: string
}

const FirmContacts: React.FC<FirmContactsProps> = ({
    productName,
    activeFirmName,
    assignedContactUsers,
    currentUserInfo,
}) => {
    const classes = useStyles()
    return (
        <GridContainer data-testid="dvContacts">
            <GridItem className={classes.linksHeadingContainer}>
                <Typography variant="h3" className={classes.linksHeading}>
                    Contact:
                </Typography>
            </GridItem>
            <GridItem className={classes.itemContainer}>
                {assignedContactUsers?.length! > 0 ? (
                    <ViewFirmContacts
                        contacts={assignedContactUsers ?? []}
                        productName={productName}
                        sender={{
                            name: `${currentUserInfo?.firstName} ${currentUserInfo?.lastName}`,
                            activeFirmName: activeFirmName,
                            email: currentUserInfo?.email,
                        }}
                    />
                ) : (
                    <Typography variant="body2" className={classes.noContacts}>
                        None
                    </Typography>
                )}
            </GridItem>
        </GridContainer>
    )
}
export default FirmContacts
